module.exports = [
  {
    title:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam optio accusantium nostrum.",
    content: `
    Lorem, ipsum dolor sit amet consectetur adipisicing elit.<br>
    <b>Nesciunt ipsam cum incidunt</b> quia deserunt perferendis exercitationem similique? Molestias amet nam quasi facere. <br>
    <i>Aut dolore mollitia amet dolorum</i> culpa maiores minima soluta laudantium, quia atque beatae nulla provident sequi? Quas, odit.
    `,
  },
];
